import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { MenuItem, Divider } from 'material-ui';
import { SelectField } from 'redux-form-material-ui';
import { getEntities, tournamentsKey } from 'dash-front/selectors';
import { fetchTournamentsBySport } from 'dash-front/actions/tournaments';

class TournamentPicker extends React.PureComponent {
    componentDidMount() {
        this.props.updateTournaments(this.props.sport);
    }

    componentWillReceiveProps({ sport }) {
        if (this.props.sport !== sport) {
            this.props.updateTournaments(this.props.sport);
        }
    }

    renderOptions() {
        const { tournaments } = this.props;
        if (!Array.isArray(tournaments)) {
            return null;
        }
        return tournaments.map(({ id, name }) => <MenuItem key={id} primaryText={name} value={String(id)} />);
    }

    render() {
        const { name } = this.props;
        const fieldProps = _.omit(this.props, Object.keys(TournamentPicker.propTypes));
        const options = this.renderOptions();
        return (
            <Field floatingLabelText={'Tournament (league)'} {...fieldProps} name={name} component={SelectField}>
                {/* <MenuItem value={'*'} primaryText={'Any'} />
                {_.get(options, 'length') ? <Divider /> : null} */}
                {options}
            </Field>
        );
    }
}

TournamentPicker.propTypes = {
    name: PropTypes.string.isRequired,
    sport: PropTypes.string,
    tournaments: PropTypes.array,
    updateTournaments: PropTypes.func.isRequired
};

const mapStateToProps = (state, { sport }) => ({
    tournaments: getEntities(state)[tournamentsKey(sport)]
});

const mapDispatchToProps = dispatch => ({
    updateTournaments: sport => dispatch(fetchTournamentsBySport(sport))
});

export default connect(mapStateToProps, mapDispatchToProps)(TournamentPicker);



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/pickers/TournamentPicker2.js
 **/